angular.module('picmonic-common').directive('nursingPlannerBanner', [
  function () {
    return {
      restrict: 'E',
      template:
        '<div ng-if="visible" class="nursing-planner-banner"><i class="picmonic-icons md-24 m-r-1">gift_thick</i><strong class="m-r-1">December Bonus:</strong> Free 2021 Nursing School Planner Digital Download with Annual+ Plans <img alt="" pls-srcset="/assets/img/banners/nursing-planner-icon.png"/></div>',
      replace: true,
      controller: [
        '$scope',
        function ($scope) {
          $scope.now = Math.floor(new Date().getTime() / 1000);

          $scope.startTime = 1608102000; // 12/16/2020 @ 7:00am (UTC)
          $scope.endTime = 1609397999; // 12/31/2020 @ 6:59am (UTC)

          $scope.visible = $scope.now < $scope.endTime;
        },
      ],
    };
  },
]);
